import { styled } from "styled-components";

export const ReviewInput = styled.textarea`
  width: 100%;
  height: 12%;
  padding: 12px;
  margin-top: 24px;
  border: 1px solid #383838;
  border-radius: 4px;
  font-size: 18px;
  resize: vertical;
`;
